"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapped = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Wrapped_module_css_1 = __importDefault(require("./Wrapped.module.css"));
/**
 *
 */
function Wrapped({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: Wrapped_module_css_1.default.wrapped, children: children });
}
exports.Wrapped = Wrapped;
//# sourceMappingURL=Wrapped.js.map